import styled from 'styled-components';
import { COLOR } from '../../../constant-styles';

// Styled component para cada línea de texto
export const Line = styled.div<{
	fontSize: number;
	lineHeight: number;
	isFirst: boolean;
	hasSpace: boolean;
	hasElement: boolean;
	numberOfWords: number;
	numberOfLetters: number;
	isShowroom: boolean;
}>`
	font-size: ${({ fontSize }) => fontSize}px;
	font-size: ${(props) => (props.hasSpace || props.numberOfWords > 1) && props.fontSize - 10}px;
	font-size: ${(props) => props.hasElement && props.fontSize - 40}px;

	${({ lineHeight, isFirst }) => `
        line-height: ${lineHeight}px;
        ${isFirst ? 'margin-top: 0;' : ''};
    `};

	@media screen and (max-width: 560px) {
		font-size: ${(props) => props.hasElement && props.numberOfLetters < 6 && props.fontSize + 50}px;
		font-size: ${(props) => props.hasElement && props.numberOfLetters > 4 && props.fontSize + 10}px;
	}

	// Tablet size
	@media screen and (min-width: 960px) and (max-width: 1199px) {
		width: 100%;
		text-align: start;
		font-size: ${(props) => props.isFirst && props.numberOfLetters === 5 && props.fontSize + 30}px;
		font-size: ${(props) => props.isFirst && props.numberOfLetters > 5 && props.fontSize + 20}px;
		font-size: ${(props) => !props.isFirst && props.numberOfLetters === 5 && props.fontSize + 60}px;
		font-size: ${(props) => props.hasElement && props.numberOfLetters < 5 && props.fontSize + 80}px;
	}

	@media screen and (min-width: 1200px) {
		font-size: ${(props) => props.hasElement && props.numberOfLetters < 5 && props.fontSize + 120}px;
		font-size: ${(props) => props.numberOfLetters > 4 && props.fontSize + 10}px;
	}
`;

// Styled component para el contenedor del texto
export const TextContainer = styled.div<{ isShowroom: boolean }>`
	font-family: var(--font-family-head);
	font-weight: bold;
	color: transparent;
	-webkit-text-stroke: 3px ${COLOR.STROKE};
	z-index: -2;

	height: 100%;
	width: 100%;
	align-content: center;

	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;

	@media screen and (max-width: 959px) {
		position: absolute;
		top: var(--size-dynamic0250);
		height: 27%;
		align-items: center;
	}

	@media screen and (min-width: 560px) and (max-width: 959px) {
		top: var(--size-dynamic0300);
		height: 22%;
	}

	// Tablet size
	@media screen and (min-width: 960px) and (max-width: 1199px) {
		position: absolute;
		top: ${(props) => (props.isShowroom ? 'var(--size-dynamic0120)' : 'var(--size-dynamic0270)')};

		height: 35%;
		gap: 5%;

		padding-left: ${(props) => (props.isShowroom ? 'var(--size-grid001)' : 'var(--size-grid004)')};
		padding-right: 'var(--size-grid001)';

		overflow: ${(props) => props.isShowroom && 'visible'};
	}

	@media screen and (min-width: 1200px) {
		gap: 3%;
		overflow: visible;
		padding-left: 10%;
	}
`;

export const ModelTitleBackgroundContainer = styled.div<{
	isShowroom: boolean;
}>`
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	align-content: center;

	//Esto nos permite que el texto haga overflow
	& * {
		overflow: visible !important;
	}

	Tablet size @media screen and (min-width: 960px) and (max-width: 1199px) {
		height: ${(props) => props.isShowroom && ' 25vh'};
	}
`;
